import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';
import musicFile from '../../asset/music/iu_ma.mp3'



const ParkMinJung = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "임현택 ♡ 박민정 결혼합니다.";
    const openDesc = "9월 20일 토요일 오후 1시 30분\n(동촌 노비아갈라)";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/225/thumb.jpg";

    const lng = 128.65172523019;
    const lat = 35.8879838886664;

    const placeTelNum = "1800-1999";

    const forBus = " ·  일반버스 : 동구1, 동구1-1, 동구2, 동구3, \n                           618, 805, 808, 836, 980\n ·  좌석버스 : 719";
    const forSubway = "1호선 동촌역 1, 4번 출구";
    const forCar = " ·  주 소 \n대구 동구 동촌로 87 '동촌 노비아갈라'\n※ 타 지방에서 차량 이용 시 팔공산 IC가 편리합니다.";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 올리브
        concept: "SUMMER",
        titleColor: "#405200",
        pointColor: "#405200",
        btnBgColor: "#405200",
        fontColor: "#fff",
        btnFontColor: "#fff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "We are getting married♡";

    const msg1 = "\"어떤 이유로 만나 사랑을 하고\n어떤 이유로 내게 와 함께 있어준 당신,\n부디 행복한 날도 살다 지치는 날도\n모두 그대 곁에 내가 있어줄 수 있길.\"";
    const msg2 = "- 아이유, 마음을 드려요 中 -\n"
    const msg3 = "우리는 '우연'으로 만나 '연인'이 되었습니다.\n이제는 평생에 '인연'이 되고자 합니다."
    const msg4 = "소중한 분들을 초대합니다.\n\n\n";


    const parents = [
        {groom : "임종수 · 이효희의 아들"},
        {bride : "박대식 · 채윤경의 딸"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "임현택",
            bank: "신한은행",
            accountNumber : "110-279-013781",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FCy72N7VQ"
        }
        ,{
            role: "신랑 부",
            name: "임종수",
            bank: "농협은행",
            accountNumber : "717029-52-053588",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "이효희",
            bank: "농협은행",
            accountNumber : "717029-52-070985",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "박민정",
            bank: "아이엠뱅크",
            accountNumber : "508-12-860346-1",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej8G8o4Hv"
        }
        ,{
            role: "신부 부",
            name: "박대식",
            bank: "농협은행",
            accountNumber : "352-1043-7853-93",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "채윤경",
            bank: "아이엠뱅크",
            accountNumber : "231-13-077948",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 가지지 않으셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "아름다웠어♥",
            brideAnswer: "좀 멋있더라"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "실감이 안나",
            brideAnswer: "믿기지않아"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "내가 지켜줄게",
            brideAnswer: "항상 고마워"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "청소는 내가~",
            brideAnswer: "요리는 내가~"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "민정아 사랑해",
            brideAnswer: "행복하자🖤"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "권유안",
            call: "010-2340-2172"
        }
        ,{
            role: "신랑 부",
            name: "권길택",
            call: "010-7979-1172"
        }
        ,{
            role: "신랑 모",
            name: "박미숙",
            call: "010-7302-1173"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "정소현",
            call: "010-9043-2745"
        }
        ,{
            role: "신부 부",
            name: "정태진",
            call: "010-3768-2286"
        }
        ,{
            role: "신부 모",
            name: "김현옥",
            call: "010-2745-2286"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#405200"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicFile}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#405200"} letteringFontColor={"#ffffff"} dateColor={"#ffffff"} bottom={"28%"} bottom2={"18.5%"} dateBottom={"2%"} top={"1%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2 parents={parents} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forCar={forCar} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default ParkMinJung;